/* eslint-disable */
import { TextStyle } from './common';
const baseCodeBlockData = {};
export const CodeBlockData = {
    fromJSON(object) {
        const message = Object.assign({}, baseCodeBlockData);
        message.textStyle =
            object.textStyle !== undefined && object.textStyle !== null
                ? TextStyle.fromJSON(object.textStyle)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.textStyle !== undefined &&
            (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : undefined);
        return obj;
    },
};
//# sourceMappingURL=node_code_block.js.map